<template>
  <div class="group-item">
    <a class="group-item-icon" :href="card.href" target="_blank">
      <img class="group-item-icon-img" :src="card.src" alt="product-icon" title="product-icon">
    </a>
    <div class="group-info-group">
      <div class="group-info">
        <a class="title" :href="card.href" target="_blank">{{ card.cardName }}
          <sup v-if="card.type!==''" :class="card.type">{{ typeDesc }}</sup></a>
        <a class="discription" :href="card.href"
           target="_blank" :title="card.description">{{ card.description }}</a>
      </div>
      <div class="group-info-button">
        <a class="linkbutton" :href="card.href" target="_blank">{{card.button}}</a>
        <span v-if="card.tips!==''" class="linkbotton-tips">{{ card.tips }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps,computed} from 'vue'
const props = defineProps(['card'])

const typeDesc = computed(() => {
  if (props.card.type === 'hot') {
    return '热门'
  } else if (props.card.type === 'new') {
    return '最新'
  } else {
    return ''
  }
})
</script>

<style scoped>
.group-info-group a.title {
  color: var(--laputa-black);
  font-size: 20px;
  line-height: 1;
  margin-bottom: 8px;
  width: fit-content;
  position: relative;
  font-weight: bold;
}

.group-info-group a.discription {
  color: var(--laputa-black);
  font-size: 14px;
  width: fit-content;
  max-width: 220px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; /* 这里是超出几行省略 */
  overflow: hidden;
}
.group-item {
  display: flex;
  padding: 20px;
  width: 100%;
  height: 100%; /* 关键！撑满grid单元格，才能垂直居中 */
  align-items: center; /* 内部flex垂直居中，图片+文字块整体在卡片盒子中间 */
}
a.group-item-icon {
  width: 100px;
  height: 100px;
  flex-shrink: 0; /* 图片禁止压缩 */
}
img.group-item-icon-img {
  width: 100px;
  height: 100px;
  border-radius: 28px;
  object-fit: cover;
}
.group-info-group {
  margin-left: 36px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100px;
  flex:1;
}
.group-info {
  display: flex;
  flex-direction: column;
}
.group-info-group a.title {
  color: var(--laputa-common-font-color);
  font-size: 20px;
  line-height: 1;
  margin-bottom: 8px;
  width: fit-content;
  position: relative;
  font-weight: bold;
}
.group-info-group a.discription {
  color: var(--laputa-common-secondary-font-color);
  font-size: 14px;
  width: fit-content;
  max-width: 220px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.group-info-button {
  display: flex;
  align-items: center;
}
a.linkbutton {
  padding: 6px 20px;
  display: flex;
  background: var(--laputa-btn-background);
  color: var(--laputa-common-inverse-font-color);
  font-size: var(--laputa-fontsize-14);
  border-radius: 21px;
  transition: ease-in-out 0.3s;
  width: fit-content;
  white-space: nowrap;
}
a.linkbutton:hover {
  background: var(--laputa-card-background-private-blue);
  color: var(--laputa-white);
}
a.linkbutton:active {
  filter: brightness(0.8);
}
span.linkbotton-tips {
  display: flex;
  margin-left: 10px;
  font-size: var(--laputa-fontsize-12);
  color: var(--laputa-common-thirdary-font-color);
}

@media screen and (max-width: 375px) {
  .group-item {
    flex-direction: row;
  }
  img.group-item-icon-img, a.group-item-icon {
    width: 40px;
    height: 40px;
    border-radius: 12px;
  }
  .group-info-group {
    margin-left: 20px;
    flex-direction: column;
    width: 100%;
    height: 45px;
  }
  .group-info-button {
    margin-top: 0px;
    flex-direction: column;
    align-items: flex-start;
  }
  a.linkbutton {
    margin-left: 0px;
  }
  span.linkbotton-tips {
    margin-top: 4px;
    margin-left:0;
  }
}
a {
  text-decoration: none;
  user-select: none;
  -webkit-user-drag: none;
}
span {
  user-select: none;
}
sup {
  font-size: 12px;
  background: var(--laputa-green);
  color: var(--laputa-card-background-white);
  padding: 4px;
  border-radius: 4px;
  margin-left: 6px;
  white-space: nowrap;
  position: absolute;
  top: -4px;
}
sup.hot {
  background: var(--laputa-red);
}

img {
  user-select: none;
  -webkit-user-drag: none;
}
/* ============ 手机端通用适配（≤768px） ============ */
@media screen and (max-width: 768px) {
  .group-item {
    padding: 14px;
    align-items: center;
    /* 不要写死高度，让卡片内容自然撑开 */
    height: auto;
  }

  a.group-item-icon,
  img.group-item-icon-img {
    width: 52px;
    height: 52px;
    border-radius: 14px;
    flex-shrink: 0;
  }

  .group-info-group {
    margin-left: 12px;
    /* 信息区不要写死100px，否则标题+描述+按钮在窄屏会被挤变形 */
    height: auto;
    gap: 6px;
    min-width: 0; /* 关键：允许文字区收缩，不被长标题撑破 */
  }

  .group-info {
    min-width: 0;
  }

  .group-info-group a.title {
    font-size: 15px;
    margin-bottom: 4px;
    line-height: 1.2;
    /* 长标题在窄卡片里换行而不是溢出 */
    width: 100%;
  }

  .group-info-group a.discription {
    font-size: 12px;
    /* 关键：去掉 max-width: 220px 的限制，按卡片实际宽度走 */
    max-width: 100%;
    line-height: 1.4;
  }

  .group-info-button {
    margin-top: 4px;
    flex-wrap: wrap;
    gap: 6px;
  }

  a.linkbutton {
    padding: 4px 12px;
    font-size: 12px;
    border-radius: 16px;
  }

  span.linkbotton-tips {
    font-size: 11px;
    margin-left: 0;
  }

  sup {
    font-size: 10px;
    padding: 2px 4px;
    top: -2px;
  }
}
</style>
